import type {I18n} from "vue-i18n";

export default defineNuxtPlugin({
    name: 'i18n-sync',
    dependsOn: ['i18n'],
    setup(nuxtApp) {
        const languageStore = useLanguageStore()
        const i18n = nuxtApp.$i18n as I18n['global'] // ✅ instance globale
        if (!i18n) {
            console.error('[i18n-sync] i18n is not available')
            return
        }
        const locale = i18n.locale as Ref<string> // Ref<string>
        watch(
            () => languageStore.currentLanguage,
            (value) => {
                if (!value?.id || !value?.country) return

                // 🔒 protection legacy data
                if (!/^[a-z]{2}$/i.test(value.id)) {
                    console.warn("Invalid persisted language id", value)
                    return
                }

                const localeCandidate =
                    `${value.id.toLowerCase()}-${value.country.toUpperCase()}`

                locale.value = localeCandidate
            },
            {immediate: true}
        )
    }
})